<template>

	<div class="" @mouseleave="menuMouseLeave">
		<div class="top-menu flex alit justb" :style="{background:`rgba(0, 0, 0, ${topbackOpacity})`}">
			<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/logo2.png"
				style="width: 115px;margin-left: 30px;" alt="" />
			<div class="flex" style="margin-right: 100px;">
				<div class="" :class="routerIndex.includes(index) ? 'router-check' : 'router-defalut'"
					v-for="(item,index) in routerList" :key="index" @click="routerChange(item.router,index)"
					@mouseover="index == 1 ? menuShow = true : menuShow = false,routerIndex[1] = index">
					{{item.title}}
				</div>
			</div>
		</div>
		<div class="router-menu flex justc" style="align-items: start;" v-if="menuShow" @mouseleave="menuMouseLeave">
			<div class="flexCol alit justc" style="margin-top: 0;">
				<div class="" style="font-size: 26px;font-weight: 900;margin-top: 10px;">数字化工具</div>
				<div class="check-menu" @click="routerChange('ica',1)">ICA大数据服务平台</div>
				<div class="check-menu" @click="routerChange('gjldmx',1)">广积粮大模型</div>
				<div class="check-menu" @click="routerChange('dkyg',1)">低空遥感</div>
				<div class="check-menu" @click="routerChange('ai',1)">千寻AI</div>
				<div class="check-menu" @click="routerChange('xlsy',1)">全链溯源</div>
				<div class="check-menu" @click="routerChange('huoguogo',1)">交易平台</div>
			</div>
			<div class="flexCol alit justc" style="margin-left: 200px;margin-top: 0;">
				<div class="" style="font-size: 26px;font-weight: 900;margin-top: 10px;">数字农业解决方案</div>
				<div class="check-menu" @click="routerChange('facilityAgriculture',1)">设施农业</div>
				<div class="check-menu" @click="routerChange('fieldCultivation',1)">大田种植</div>
				<div class="check-menu" @click="routerChange('smartFarming')">智慧养殖</div>
				<div class="check-menu" @click="routerChange('industrialBrain')">产业大脑</div>
				<div class="check-menu" @click="routerChange('agriculture')">数字三农</div>
			</div>
		</div>
	</div>
	<router-view></router-view>
	<div class="footer">
		<div class="banxin">
			<div class="top flex justc">
				<div class="rightBox">
					<div class="aboutUs">
						<p class="title pointer" @click="goPage('aboutUs')">关于我们</p>
						<p class="pointer" @click="goPage('concatUs')">联系我们</p>
					</div>
					<!-- <div class="aboutUs">
						<p class="pointer" @click="goPage('procurementGuidelines')">采购指南</p>
						<p class="pointer" @click="goPage('privacyPolicy')">隐私政策</p>
					</div> -->
					<div class="aboutUs">
						<p class="title" @click="openUrl('http://sp.18yimu.com/#/')">智慧农业智控中心</p>
						<p class="pointer" @click="openUrl('https://www.huoguogo.cn/login')">火锅产业要素交易平台</p>
						<p class="pointer" @click="openUrl('http://kzrtdn.18yimu.com/new/#/')">肉兔产业大脑</p>
					</div>
					<div class="aboutUs">
						<p class="title" @click="goPage('financialService')">金融服务</p>
						<p class="pointer" >登录后台</p>
					</div>

					<div class="leftBox flexCol" style="margin: 0 -80px 0 200px;">
						<p class="title" style="font-size: 17px;">客服电话</p>
						<p class="number" style="width: 300px;font-size: 16px;">电话：139 8305 7567</p>
						<p class="time" style="font-size: 16px;">服务时间：09:00 - 23:00</p>
						<div class="consult">在线咨询</div>
					</div>
					<div class="qrCode" style="margin-right: 10px;margin-left: 120px;">
						<div class="flexCol alit title">
							<div class="" style="font-size: 14px">下载App</div>
							<div class="" style="font-size: 12px;margin: 10px 0 5px 0;">重庆火锅产业要素交易平台</div>
						</div>
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/appcode.png" alt="" />
					</div>
					<div class="qrCode">
						<p class="title" style="font-size: 14px;margin-bottom: 25px;">关注微信小程序</p>
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/hotpotNew/index/minQRCode.jpg"
							alt="" />
					</div>
				</div>
			</div>
			<p class="bottom" style="margin-bottom: 5px;">
				&copy;营业执照|增值电信业务经营许可证
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/%E7%BD%91%E8%AD%A6.png"
					style="width:20px;margin-left: 20px;margin-right: 5px;" alt="" />
				<a href="https://www.cpd.com.cn/" rel="noreferrer" target="_blank">网络警察提醒您</a>
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hotpot/%E7%9F%A5%E8%AF%86%E4%BA%A7%E6%9D%83.png"
					style="width:20px;margin-left: 20px;margin-right: 5px;" alt="" />
				<a href="https://ggfw.cnipa.gov.cn/" rel="noreferrer" target="_blank">国家知识产权公共服务网</a>
			</p>
			<p class="bottom">
				&copy;2017-2024重庆火锅产业要素交易平台版权所有，并保留所有权利 &nbsp;&nbsp;&nbsp;&nbsp;
				<a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">渝ICP备2023010903号-3</a>
				<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/hotpotNew/index/ga.png"
					style="width:20px;margin-left: 20px;margin-right: 5px;" alt="" />
				<a href="https://beian.mps.gov.cn/#/query/webSearch?code=50019002504107/" rel="noreferrer"
					target="_blank">渝公网安备50019002504107</a>
			</p>
		</div>
	</div>
</template>

<script setup>
	import {
		ref,
		onMounted
	} from 'vue'
	import {
		useRouter
	} from 'vue-router';
	const router = useRouter();
	const routerIndex = ref([0])
	const menuShow = ref(false)
	const topbackOpacity = ref(0)
	const routerList = ref([{
			title: '首页',
			router: '/'
		}, {
			title: '产品与服务',
			router: 'smartAgriculture'
		},
		{
			title: '智能装备',
			router: '/smartEquipment'
		},
		{
			title: '交易平台',
			router: 'hotPot'
		}, {
			title: '典型案例',
			router: '/typicalCase'
		},
		{
			title: '新闻动态',
			router: '/companyNews'
		}, 
		// {
		// 	title: '金融服务',
		// 	router: '/financialService'
		// },
		{
			title: '关于我们',
			router: '/aboutUs'
		}
		// , {
		// 	title: '联系我们',
		// 	router: '/concatUs'
		// }
	])

	// 在组件挂载时添加滚动事件监听器
	onMounted(() => {
		window.addEventListener('scroll', handleScroll);
	});

	// 定义处理滚动事件的函数
	const handleScroll = () => {
		const y = window.scrollY
		if (y < 20) {
			topbackOpacity.value = 0
		} else if (y > 100) {
			topbackOpacity.value = 0.7
		}
	};

	function menuMouseLeave() {
		menuShow.value = false;
		routerIndex.value[1] = -1
	}

	function routerChange(e, index) {
		if(e == 'hotPot'){
			window.open('https://www.huoguogo.cn/')
			menuMouseLeave()
			routerIndex.value[0] = index
			router.push('huoguogo')
		}else{
			menuMouseLeave()
			routerIndex.value[0] = index
			router.push(e)
		}
		
	}

	function goPage(e) {
		router.push(e)
	}

	function openUrl(e) {
		window.open(e)
	}
</script>

<style scoped lang="scss">
	.bottom-top-title {
		font-family: Microsoft YaHei;
		font-weight: 400;
		font-size: 14px;
		color: #141414;
		margin-top: 9px;
	}

	.bottom-top {
		width: 100%;
		height: 84px;
		background: #F7F7F7;
	}

	.footer {
		width: 100%;
		height: 410px;
		color: #777777;
		overflow: hidden;

		.banxin {
			padding-top: 30px;
			width: 100%;
			height: 410px;
			margin: 0 auto;
			// background-image: url('https://qgst.obs.cn-southwest-2.myhuaweicloud.com/hg/home/%E7%BB%84%2012431%402x.png');
			// background-size: 100% 100%;
			background-color: #F7F7F7;
			border-top: 1px solid #C2CDD7;

			.top {
				// margin-top: 30px;
				display: flex;
				margin-bottom: 38px;
				// text-align: center;

				.leftBox {
					display: flex;
					flex-direction: column;

					.title {
						font-size: 16px;
						margin-bottom: 33px;
					}

					.number {
						font-size: 40px;
						margin-bottom: 12px;
						font-weight: 500;
					}

					.time {
						font-size: 18px;
						margin-bottom: 33px;
						color: #777777;
					}

					.consult {
						cursor: pointer;
						// margin: 0 auto;
						width: 100px;
						height: 36px;
						line-height: 36px;
						border: 1px solid #777777;
						box-sizing: border-box;
						opacity: 1;
						text-align: center;
					}
				}

				.centerBox {
					flex: 1;
					border-left: 2px solid rgba($color: #777777, $alpha: 0.15);
					border-right: 2px solid rgba($color: #777777, $alpha: 0.15);

					p {
						font-size: 16px;
						line-height: 25px;
					}

					.title {
						margin-bottom: 33px;
					}
				}

				.rightBox {
					display: flex;

					.aboutUs {
						margin: 0 30px;

						p {
							margin-bottom: 20px;
						}

						.title {
							margin-bottom: 20px;
							cursor: pointer;
						}
					}

					.qrCode {
						// margin-top: -10px;
						flex: 1;
						display: flex;
						flex-direction: column;
						justify-content: space-around;
						align-items: center;

						.title {
							// margin-bottom: 33px;
							width: 165px;
							text-align: center;
						}

						img {
							width: 106px;
							height: 106px;
						}
					}
				}
			}

			.bottom {
				text-align: center;
				font-size: 12px;
				line-height: 0;
				color: #777777;
				// display: flex;
				// align-items: center;
				// justify-content: center;
			}
		}
	}

	.router-menu {
		position: fixed;
		width: 100%;
		height: 400px;
		background-color: rgba(0, 0, 0, 0.6);
		top: 100px;
		z-index: 99;
		animation: fadeIn 0.5s forwards;
		color: #fff;

		.check-menu {
			cursor: pointer;
			margin-top: 30px;
		}

	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.router-defalut {
		height: 100px;
		line-height: 100px;
		width: 140px;
		text-align: center;
		font-size: 20px;
		color: #fff;
		cursor: pointer;
	}

	.router-defalut:hover {
		background-color: #8e000a;
	}

	.router-check {
		height: 100px;
		line-height: 100px;
		width: 140px;
		background-color: #8e000a;
		text-align: center;
		font-size: 20px;
		color: #fff;
		cursor: pointer;
	}

	.company-name {
		color: #fff;
		font-size: 26px;
		line-height: 100px;
	}

	.top-menu {
		position: fixed;
		width: 100%;
		height: 100px;
		// background-color: rgba(0, 0, 0, 0.6);
		top: 0;
		z-index: 99;
	}

	.top-menu:hover {
		// background-color: rgba(0, 0, 0, 0.6);
	}
</style>